import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class ProductDetails extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {
      expanded: this.props.diamondDetails,
    };
	}

	componentDidMount() {

  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  toggleExpanded() {
    this.setState({ expanded: !this.state.expanded });
  }

  getSectionTitle() {
    if(this.props.diamondDetails) {
      return 'Diamond Details';
    } else if(this.props.genericPage) {
      return 'Jewelry Details';
    } else {
      return 'Setting Details';
    }
  }

  getGetSettingImgUrl() {

    let typevalue = null;
    for(let i = 0; i < this.props.details.length; i++) {
      if(this.props.details[i].key == 'Type') {
        typevalue = this.props.details[i].value;
        break;
      }
    }

    if(!typevalue) {
      return 'solitaire_1.svg';
    }

    switch(typevalue) {
      case 'SOLITAIRE':
        return 'solitaire_1.svg';
      case '3-STONE':
        return 'three_stone_1.svg';
      case 'HALO':
        return 'halo_1.svg';
      case 'DIAMOND ACCENTED':
        return 'pave_1.svg';
    }
  }

	render() {
		return <div className='ProductDetails'>
			<div className='detailsHeader' onClick={::this.toggleExpanded}>
        <div className='headerLabel'>{this.getSectionTitle()}</div>
        {this.state.expanded ?
          <div className='headerIcon'>&mdash;</div> :
          <div className='headerIcon'>+</div>
        }
      </div>
      <div className={this.state.expanded ? 'detailsBody expanded' : 'detailsBody'}>
        {!this.props.diamondDetails && !this.props.genericPage ?
          <div className='detailSettingDiagram'>
            <img src={'https://ddw2.diamondsdirect.com/img/productpage/details/' + this.getGetSettingImgUrl()} />
          </div> :
          null
        }  
        <div className={this.props.diamondDetails ? 'detailBodyWrapper diamondDetail' : 'detailBodyWrapper settingDetail'}>
          {this.props.details.map((deet, i) => {
            return <div className={this.props.diamondDetails ? 'detailItem diamondDetail' : 'detailItem settingDetail'} key={i}>
              {this.props.diamondDetails ?
                <div className='detailLabel'>{deet.key}</div> :
                <div className='detailLabel'>{deet.key}:</div>
              }
              <div className='detailValue'>{deet.value}</div>
            </div>;
          })}
        </div>
      </div>
		</div>;
	}
}
export default ProductDetails;

function mapStateToProps(state) {
  return {

  };
}

export const ProductDetailsContainer = connect(
  mapStateToProps,
  allActionCreators
)(ProductDetails);


// WEBPACK FOOTER //
// ./src/components/views/product-page/blocks/ProductDetails.jsx